import React from 'react'
import PropTypes from 'prop-types'

import Box from '../Box'

import Actions from './Actions'
import Paragraph from './Paragraph'
import Title from './Title'

const BlankState = (props) => {
  const {
    boxProps, children, imageUrl, sidebar, style,
  } = props

  return (
    <Box
      backgroundColor="white"
      border={sidebar ? 'none' : '1px solid'}
      borderColor="lineColor"
      borderRadius={5}
      flexDirection={sidebar ? 'column-reverse' : ['column-reverse', 'row']}
      padding={sidebar ? 'none' : 'xlarge'}
      style={style}
      {...boxProps}
    >
      <Box
        flexDirection="column"
        justifyContent="center"
        marginRight={sidebar ? 0 : [0, 'large']}
        width={sidebar ? '100%' : ['100%', 320]}
      >
        {children}
      </Box>

      {imageUrl && (
        <Box
          alignItems="center"
          justifyContent="center"
          marginLeft={sidebar ? 0 : [0, 'auto']}
          marginBottom={sidebar ? 'large' : ['large', 0]}
          width={sidebar ? '100%' : ['100%', 340]}
        >
          <img alt="Blank State" src={imageUrl} style={{ maxWidth: '100%' }} />
        </Box>
      )}
    </Box>
  )
}

BlankState.propTypes = {
  boxProps: PropTypes.object,
  children: PropTypes.node,
  imageUrl: PropTypes.string,
  sidebar: PropTypes.bool,
  style: PropTypes.object,
}

BlankState.Actions = Actions
BlankState.Paragraph = Paragraph
BlankState.Title = Title

export default BlankState
